// Top-bar trail for host routes, by route name: `label` is an i18n key and
// `parent` the route linked before it (resolved with the current params, so a
// class sub-page links back to its own class). Routes not listed have no
// trail; v2 pages that publish their own trail take precedence (App.vue).
const CLASS_SUB = (label) => ({ label, parent: 'ClassDetail' })

const TRAIL = {
  LegacyHome: { label: 'CRUMB_LEGACY_HOME' },
  NewsDetail: { label: 'CRUMB_NEWS' },
  School: { label: 'MENU_SETTING' },
  MentorHouse: { label: 'MENU_MENTOR_HOUSE' },
  Reports: { label: 'MENU_REPORT' },
  Profile: { label: 'MENU_PROFILE' },
  PricingPlan: { label: 'CRUMB_PRICING' },
  Contact: { label: 'CRUMB_CONTACT' },
  SchoolBookCategory: { label: 'SCHOOL_BOOK_CATEGORY' },

  Plan: { label: 'MENU_PLAN' },
  PlanLeader: { label: 'THE_EDUCATION_PLANS_OF_THE_SPECIALIZED_GROUP', parent: 'Plan' },
  PlanLeaderDetail: { label: 'CRUMB_DETAIL', parent: 'PlanLeader' },
  PlanTeacher: { label: 'TEACHERS_EDUCATION_PLANS', parent: 'Plan' },
  PlanTeacherDetail: { label: 'CRUMB_DETAIL', parent: 'PlanTeacher' },
  PlanLesson: { label: 'LESSON_PLANS', parent: 'Plan' },
  PlanLessonDetail: { label: 'CRUMB_DETAIL', parent: 'PlanLesson' },

  Class: { label: 'MENU_CLASS' },
  ClassDetail: { label: 'CRUMB_CLASS_DETAIL', parent: 'Class' },
  ClassFileHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  EasyClassHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  EasyAIHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  CourseMarketplaceHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  UnistartHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  MpHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassAttachmentHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  DocumentHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassQuestionHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassVocabularyHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassConversationHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassWritingHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassVideoHomework: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassQuestionLiveExam: CLASS_SUB('CRUMB_HOMEWORK_NEW'),
  ClassHomeWorkDetail: CLASS_SUB('CRUMB_HOMEWORK_DETAIL'),
  CreateMission: CLASS_SUB('MISSION'),
  UpdateMission: CLASS_SUB('MISSION'),
  CreateMissionChain: CLASS_SUB('MISSION'),
  UpdateMissionChain: CLASS_SUB('MISSION'),
  MissionDetail: CLASS_SUB('MISSION'),
  MissionChainDetail: CLASS_SUB('MISSION'),
  RCVContestDetail: CLASS_SUB('RCV_CONTEST'),
  RaceChallengeDetail: CLASS_SUB('RACE_CHALLENGE'),
  RaceChallengeMissionQuestions: { label: 'RACE_CHALLENGE' },
  OutingGameDetail: { label: 'OUTING_GAME' },
  OutingGameMissionQuestions: { label: 'OUTING_GAME' },
  InteractiveHomework: { label: 'CRUMB_LIVE_EXAM' },

  ListClassHomework: { label: 'MENU_EXERCISE' },
  ListClassStudy: { label: 'MENU_LESSON' },
  ListTeacher: { label: 'MENU_TEACHER' },
  Students: { label: 'MENU_STUDENT' },
  StudentDetail: { label: 'CRUMB_STUDENT_DETAIL', parent: 'Students' },

  RTContest: { label: 'MENU_RT_CONTEST' },
  RTContestDetail: { label: 'CRUMB_DETAIL', parent: 'RTContest' },
  TRcvContest: { label: 'T_RCV_CONTEST_MENU' },
  TRcvContestDetail: { label: 'CRUMB_DETAIL', parent: 'TRcvContest' },
  Event: { label: 'MENU_EVENT' },
  EventContest: { label: 'CRUMB_DETAIL', parent: 'Event' },
  EventRanking: { label: 'MENU_HOMEWORK_LEADERBOARD', parent: 'Event' },
  EventContestQuestion: { label: 'CRUMB_QUESTIONS', parent: 'EventContest' },

  Document: { label: 'MENU_MARKETPLACE' },
  'Document-Permissions': { label: 'CRUMB_PERMISSIONS', parent: 'Document' },
  ExamVault: { label: 'MENU_EXAM_VAULT' },
  ExamVaultDetail: { label: 'CRUMB_DETAIL', parent: 'ExamVault' },
  Instruction: { label: 'MENU_INSTRUCTION' },
  InstructionDetail: { label: 'CRUMB_DETAIL', parent: 'Instruction' },

  // v2 pages that don't publish a trail of their own.
  V2ResourceAssignment: { label: 'MENU_RESOURCE_ASSIGNMENT' },
  V2HomeworkLeaderboard: { label: 'MENU_HOMEWORK_LEADERBOARD' },
  V2StudentProfile: { label: 'CRUMB_STUDENT_DETAIL', parent: 'Students' },
  V2CourseMarketplace: { label: 'CRUMB_MARKETPLACE' },
  V2CmSettings: { label: 'MENU_SETTING', parent: 'V2CourseMarketplace' },
  V2CmSales: { label: 'CRUMB_REVENUE', parent: 'V2CourseMarketplace' },
  V2CmSalesOverview: { label: 'CRUMB_REVENUE', parent: 'V2CourseMarketplace' },
  V2CmSalesOrders: { label: 'CRUMB_REVENUE', parent: 'V2CourseMarketplace' },
  V2CmSalesEnrollments: { label: 'CRUMB_REVENUE', parent: 'V2CourseMarketplace' },
  V2CmB2b: { label: 'B2B', parent: 'V2CourseMarketplace' },
  V2CmB2bBrowse: { label: 'B2B', parent: 'V2CourseMarketplace' },
  V2CmB2bOrders: { label: 'B2B', parent: 'V2CourseMarketplace' },
  V2CmB2bSellerOrders: { label: 'B2B', parent: 'V2CourseMarketplace' },
  V2CmB2bLicenses: { label: 'B2B', parent: 'V2CourseMarketplace' },
  V2CmB2bStats: { label: 'B2B', parent: 'V2CourseMarketplace' }
}

/**
 * [{ label, path? }] for `route`, starting at Trang chủ; [] when the route
 * has no entry. `t` translates i18n keys, `router` resolves parent links.
 */
export function routeBreadcrumb(route, router, t) {
  if (!route.name || !TRAIL[route.name]) return []
  const chain = []
  for (let name = route.name, guard = 0; name && guard < 6; guard++) {
    chain.unshift(name)
    name = TRAIL[name] && TRAIL[name].parent
  }
  const crumbs = chain.map((name, i) => {
    const entry = TRAIL[name]
    const label = entry.label === 'B2B' ? 'B2B' : t(entry.label)
    if (i === chain.length - 1) return { label }
    return { label, path: router.resolve({ name, params: route.params }).href }
  })
  return [{ label: t('MENU_HOME'), path: '/' }, ...crumbs]
}
